export default "__VITE_ASSET__yAID$UO___"